<script setup>
import { computed } from '#imports';

const props = defineProps({
  fillingPercent: {
    type: Number,
    default: 0,
  },
});

const fillStyle = computed(() => {
  let result;

  if (props.fillingPercent > 100) {
    result = 0;
  } else {
    result =
      props.fillingPercent === 0 ? 280 : 280 - props.fillingPercent * 2.8;
  }

  return { strokeDashoffset: result };
});
</script>

<template>
  <svg
    class="indicator"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 88 88"
    xml:space="preserve"
  >
    <circle
      class="indicator__base"
      clip-path="url(#cut-off-bottom)"
      cx="44"
      cy="44"
      r="44"
    ></circle>
    <circle
      class="indicator__fill"
      clip-path="url(#cut-off-bottom)"
      cx="44"
      cy="44"
      r="44"
      :style="fillStyle"
    ></circle>
    <defs>
      <clipPath id="cut-off-bottom">
        <path
          class="st1"
          d="M44,0C44,0,44,0,44,0c-1.1,0-2,0.9-2,2v5.2c0,1.1,0.8,2,1.9,2c1.1,0,2-0.8,2-1.9c0,0,0,0,0-0.1V2
				C46,0.9,45.1,0,44,0z"
        ></path>
        <path
          class="st1"
          d="M44,78.9C44,78.9,44,78.9,44,78.9c-1.1,0-2,0.9-2,2V86c0,1.1,0.8,2,1.9,2s2-0.8,2-1.9c0,0,0,0,0-0.1v-5.2
				C46,79.8,45.1,78.9,44,78.9z"
        ></path>
        <path
          class="st1"
          d="M55.4,1.5c-0.1,0-0.3-0.1-0.4-0.1c-0.9,0-1.8,0.6-2,1.5l-1.3,5c-0.3,1,0.3,2.1,1.4,2.4c1,0.3,2.1-0.3,2.4-1.4
				c0,0,0,0,0,0l1.3-5C57.1,2.9,56.5,1.8,55.4,1.5z"
        ></path>
        <path
          class="st1"
          d="M35,77.7c-0.1,0-0.3-0.1-0.4-0.1c-0.9,0-1.8,0.6-2,1.5l-1.3,5c-0.3,1,0.3,2.1,1.4,2.4c1,0.3,2.1-0.3,2.4-1.4
				c0,0,0,0,0,0l1.3-5C36.6,79.1,36,78,35,77.7z"
        ></path>
        <path
          class="st1"
          d="M66,5.9c-0.3-0.2-0.6-0.3-1-0.3c-0.7,0-1.4,0.4-1.7,1l-2.6,4.5c-0.5,0.9-0.2,2.1,0.7,2.7
				c0.9,0.5,2.1,0.2,2.7-0.7c0,0,0,0,0,0l2.6-4.5C67.3,7.7,67,6.5,66,5.9z"
        ></path>
        <path
          class="st1"
          d="M26.6,74.2c-0.3-0.2-0.6-0.3-1-0.3c-0.7,0-1.4,0.4-1.7,1l-2.6,4.5c-0.5,0.9-0.2,2.1,0.7,2.7s2.1,0.2,2.7-0.7
				c0,0,0,0,0,0l2.6-4.5C27.8,76,27.5,74.8,26.6,74.2z"
        ></path>
        <path
          class="st1"
          d="M71.4,19.4C71.4,19.4,71.4,19.3,71.4,19.4l3.7-3.7c0.8-0.8,0.8-2,0-2.8c-0.4-0.4-0.9-0.6-1.5-0.6v0
				c-0.5,0-1,0.2-1.3,0.6l-3.7,3.7c-0.8,0.8-0.8,2,0,2.8C69.4,20.1,70.6,20.1,71.4,19.4z"
        ></path>
        <path
          class="st1"
          d="M17.9,68.1c-0.5,0-1,0.2-1.3,0.6l-3.7,3.7c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0c0,0,0,0,0,0l3.7-3.7
				c0.8-0.8,0.8-2,0-2.8C19,68.3,18.4,68.1,17.9,68.1z"
        ></path>
        <path
          class="st1"
          d="M74.2,26.5c0.5,0.9,1.7,1.3,2.7,0.8c0,0,0,0,0.1,0l4.5-2.6c0.9-0.5,1.3-1.7,0.8-2.7c-0.3-0.6-1-1-1.6-1v0
				c-0.4,0-0.7,0.1-1.1,0.3l-4.5,2.6C74,24.4,73.6,25.6,74.2,26.5z"
        ></path>
        <path
          class="st1"
          d="M13.8,61.5c-0.3-0.6-1-1-1.6-1v0c-0.4,0-0.7,0.1-1.1,0.3l-4.5,2.6C5.7,63.8,5.3,65,5.9,66
				c0.5,0.9,1.7,1.3,2.7,0.8c0,0,0,0,0.1,0l4.5-2.6C14,63.6,14.3,62.4,13.8,61.5z"
        ></path>
        <path
          class="st1"
          d="M77.7,34.9c0.3,1,1.3,1.7,2.4,1.4c0,0,0,0,0.1,0l5-1.3c1-0.3,1.7-1.3,1.4-2.4c-0.2-0.9-1-1.5-1.9-1.5v0
				c-0.2,0-0.4,0-0.5,0.1l-5,1.3C78,32.8,77.4,33.9,77.7,34.9z"
        ></path>
        <path
          class="st1"
          d="M10.3,53c-0.2-0.9-1-1.5-1.9-1.5v0c-0.2,0-0.4,0-0.5,0.1l-5,1.3c-1,0.3-1.7,1.3-1.4,2.4c0.3,1,1.3,1.7,2.4,1.4
				c0,0,0,0,0.1,0l5-1.3C10,55.2,10.6,54.1,10.3,53z"
        ></path>
        <path
          class="st1"
          d="M86.1,42C86.1,42,86,42,86.1,42h-5.2c-1.1,0-2,0.8-2,1.9c0,1.1,0.8,2,1.9,2c0,0,0,0,0.1,0H86
				c1.1,0,2-0.8,2-1.9S87.1,42.1,86.1,42z"
        ></path>
        <path
          class="st1"
          d="M2,46h5.2c1.1,0,2-0.8,2-1.9c0-1.1-0.8-2-1.9-2c0,0,0,0-0.1,0H2c-1.1,0-2,0.8-2,1.9S0.9,45.9,2,46
				C1.9,46,2,46,2,46z"
        ></path>
        <path
          class="st1"
          d="M85.2,53C85.1,53,85.1,53,85.2,53l-5.1-1.4c-0.2-0.1-0.4-0.1-0.6-0.1v0c-1.1,0-1.9,0.9-1.9,2
				c0,0.9,0.6,1.6,1.5,1.8l5,1.3c1,0.3,2.1-0.3,2.4-1.3C86.8,54.4,86.2,53.3,85.2,53z"
        ></path>
        <path
          class="st1"
          d="M2.9,35l5,1.3c1,0.3,2.1-0.3,2.4-1.3c0.3-1-0.3-2.1-1.3-2.4c0,0,0,0-0.1,0l-5-1.3c-0.2-0.1-0.4-0.1-0.6-0.1
				c-1.1,0-1.9,0.9-1.9,2C1.4,34,2.1,34.8,2.9,35z"
        ></path>
        <path
          class="st1"
          d="M81.4,63.3C81.4,63.3,81.4,63.3,81.4,63.3l-4.5-2.6c-0.3-0.2-0.6-0.3-0.9-0.3c-1.1,0-2,0.8-2,1.9
				c0,0.7,0.4,1.4,1,1.8l4.5,2.6c0.9,0.6,2.1,0.3,2.7-0.7C82.6,65.1,82.3,63.9,81.4,63.3z"
        ></path>
        <path
          class="st1"
          d="M6.6,24.7l4.5,2.6c0.9,0.6,2.1,0.3,2.7-0.7s0.3-2.1-0.7-2.7c0,0,0,0-0.1,0l-4.5-2.6C8.3,21.1,8,21,7.7,21v0
				c-1.1,0-2,0.8-2,1.9C5.6,23.6,6,24.3,6.6,24.7z"
        ></path>
        <path
          class="st1"
          d="M75.1,72.3l-3.7-3.7c-0.4-0.4-0.9-0.6-1.4-0.6v0c-1.1,0-2,0.9-2,2c0,0.5,0.2,1,0.6,1.4l3.7,3.7
				c0.8,0.8,2,0.8,2.8,0C75.9,74.4,75.9,73.2,75.1,72.3C75.1,72.4,75.1,72.3,75.1,72.3z"
        ></path>
        <path
          class="st1"
          d="M19.3,16.6l-3.7-3.7c-0.4-0.4-0.9-0.6-1.4-0.6v0c-1.1,0-2,0.9-2,2c0,0.5,0.2,1,0.6,1.4l3.7,3.7
				c0.8,0.8,2,0.8,2.8,0S20.1,17.4,19.3,16.6C19.4,16.6,19.3,16.6,19.3,16.6z"
        ></path>
        <path
          class="st1"
          d="M66.7,79.4l-2.6-4.5c-0.4-0.6-1-1-1.8-1v0c-1.1,0-1.9,1-1.9,2c0,0.3,0.1,0.6,0.3,0.9l2.6,4.5
				c0.5,0.9,1.7,1.3,2.7,0.7S67.3,80.4,66.7,79.4C66.7,79.4,66.7,79.4,66.7,79.4z"
        ></path>
        <path
          class="st1"
          d="M23.9,13.1c0.5,0.9,1.7,1.3,2.7,0.7c0.9-0.5,1.3-1.7,0.7-2.7c0,0,0,0,0,0l-2.6-4.5c-0.4-0.6-1-1-1.8-1
				c-1.1,0-1.9,0.9-1.9,2c0,0.3,0.1,0.6,0.3,0.9L23.9,13.1z"
        ></path>
        <path
          class="st1"
          d="M56.8,84.1l-1.3-5c-0.2-0.9-1-1.5-1.8-1.5c-1.1,0-2,0.8-2,1.9c0,0.2,0,0.4,0.1,0.6l1.3,5
				c0.3,1,1.3,1.7,2.4,1.4C56.4,86.2,57,85.2,56.8,84.1C56.8,84.1,56.8,84.1,56.8,84.1z"
        ></path>
        <path
          class="st1"
          d="M32.6,8.9c0.3,1,1.3,1.7,2.4,1.4c1-0.3,1.7-1.3,1.4-2.4c0,0,0,0,0,0l-1.3-5c-0.2-0.9-1-1.5-1.8-1.5
				c-1.1,0-2,0.8-2,1.9c0,0.2,0,0.4,0.1,0.6L32.6,8.9z"
        ></path>
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="postcss" scoped>
.indicator {
  width: 100px;
  height: 100px;
  transform: rotate(-90deg);

  &__base {
    fill: #f1e2ef;
  }

  &__fill {
    fill: transparent;
    stroke-width: 25px;
    stroke: #762c80;
    stroke-dasharray: 280, 280;
  }
}
</style>
